import { Message } from "primereact/message";
import { classNames } from "primereact/utils";
import { Tag } from "primereact/tag";

import { DOMINANTE_LABELS, REVISAO } from "../../../../../nova-obra.constants";
import { TagColetor } from "../../../../../components/tag-coletor";
import { textoOuTraco } from "../../../../etapa-revisao.utils";
import styles from "../../../../etapa-revisao.module.scss";
import { Campo } from "../../../campo";
import type { TipoRevisaoProps, TipoRevisaoViewModel } from "./types-tipo-revisao";

export function TipoRevisaoView({
  tipo,
  dominante,
  nome,
  mostraClienteContrato,
  inspecaoCascoRotulo,
  testIds,
}: TipoRevisaoProps & TipoRevisaoViewModel) {
  return (
    <article className={styles.tipo} data-testid={testIds.tipo}>
      <div className={styles.tipoCabecalho}>
        <TagColetor codigo={tipo.codigo} />
        <h5 className={styles.tipoNome}>{nome}</h5>
        {dominante && <Tag severity="info" value={DOMINANTE_LABELS.selo} />}
      </div>
      {mostraClienteContrato && (
        <div className={`${styles.linha} ${styles.linhaDupla}`}>
          <Campo rotulo={REVISAO.tipos.cliente} valor={textoOuTraco(tipo.cliente)} />
          <Campo rotulo={REVISAO.tipos.contrato} valor={textoOuTraco(tipo.contrato)} />
        </div>
      )}
      {inspecaoCascoRotulo && (
        <Campo rotulo={REVISAO.tipos.inspecaoCasco} valor={inspecaoCascoRotulo} />
      )}
      <div className={styles.escoposTitulo}>
        {REVISAO.tipos.escoposMacro}
        <small>{REVISAO.tipos.escopos(0)}</small>
      </div>
      {/* Escopo Macro ainda não é coletado no wizard (HU 2479): toda pendência é calculada aqui. */}
      <Message
        severity="warn"
        role="status"
        className={classNames("p-message-block", styles.avisoSecao)}
        pt={{ text: { className: styles.avisoSecaoTexto } }}
        data-testid={testIds.semEscopo}
        text={REVISAO.tipos.semEscopo}
      />
    </article>
  );
}
